import {getFormMessages, getTicketHolderFormId} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import React from 'react'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {getExpandedTicketIndex, getIndividualReservationTickets} from '../../../selectors/checkout'
import {getEvent} from '../../../selectors/event'
import {FormSubmitButton} from '../../form-submit-button'
import {FormRef, TicketsDetailsProps} from './interfaces'
import {TicketDetails} from './ticket-details'
import s from './ticket-details.scss'

export const TicketsDetails = ({editing, formRefs, onSubmit}: TicketsDetailsProps) => {
  const {setExpandedTicketIndex, setTicketDetails} = useAppActions()

  const expandedTicketIndex = useAppSelector(getExpandedTicketIndex)
  const individualTickets = useAppSelector(getIndividualReservationTickets)
  const event = useAppSelector(getEvent)
  const messages = getFormMessages(event)
  const wixFormId = getTicketHolderFormId(event)

  const toggleExpandedTicket = (index: number) => {
    setExpandedTicketIndex(expandedTicketIndex === index ? -1 : index)
  }

  const registerFormRef = (index: number, ref: FormRef) => {
    formRefs.current[index] = ref
  }

  const getFormValues = (index: number) => formRefs.current[index]?.getValues()

  const submit = async () => {
    const validity = await Promise.all(formRefs.current.map(ref => ref?.validate()))
    const invalidIndex = validity.findIndex(value => !value)

    if (invalidIndex !== -1) {
      setExpandedTicketIndex(invalidIndex)
    } else {
      formRefs.current.forEach((ref, index) => {
        setTicketDetails({index, details: ref.getValues(), valid: true})
      })

      setExpandedTicketIndex(-1)
      onSubmit()
    }
  }

  return (
    <div className={s.container}>
      {individualTickets.map((individualTicket, index) => (
        <TicketDetails
          key={index}
          index={index}
          formId={wixFormId}
          individualTicket={individualTicket}
          editable={editing}
          expanded={index === expandedTicketIndex}
          lastTicket={index === individualTickets.length - 1}
          onExpand={() => toggleExpandedTicket(index)}
          onRegisterFormRef={ref => registerFormRef(index, ref)}
          onGetFormValues={() => getFormValues(index)}
        />
      ))}
      {editing && (
        <div className={s.button}>
          <FormSubmitButton
            dataHook={DH.FORM_BUTTON}
            text={messages.checkout.submitActionLabel || messages.rsvp.submitActionLabel}
            onClick={submit}
          />
        </div>
      )}
    </div>
  )
}
